
import Header from "@/components/Header";
import SocialMediaIcons from "@/components/SocialMediaIcons";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

const SupportPage = () => {
  return (
    <div className="min-h-screen bg-tokscript-bg text-tokscript-text flex flex-col">
      <Header />
      <main className="flex-1 pt-8">
        <div className="container mx-auto px-4 max-w-4xl">
          <h1 className="text-3xl font-bold mb-6">Support</h1>
          
          <div className="grid gap-8 md:grid-cols-2">
            {/* FAQ Section */}
            <Card className="bg-tokscript-card border-gray-800">
              <CardHeader>
                <CardTitle>Frequently Asked Questions</CardTitle>
                <CardDescription>Find answers to common questions.</CardDescription>
              </CardHeader>
              <CardContent>
                <Accordion type="single" collapsible className="w-full">
                  <AccordionItem value="item-1" className="border-gray-700">
                    <AccordionTrigger className="text-gray-200">What is TokScript?</AccordionTrigger>
                    <AccordionContent className="text-gray-300">
                      TokScript is a tool that allows you to download and archive TikTok videos, complete with transcripts and metadata in a convenient ZIP package.
                    </AccordionContent>
                  </AccordionItem>
                  
                  <AccordionItem value="item-2" className="border-gray-700">
                    <AccordionTrigger className="text-gray-200">How many videos can I download?</AccordionTrigger>
                    <AccordionContent className="text-gray-300">
                      Free users can download up to 500 videos per collection. For unlimited downloads, upgrade to our Pro plan.
                    </AccordionContent>
                  </AccordionItem>
                  
                  <AccordionItem value="item-3" className="border-gray-700">
                    <AccordionTrigger className="text-gray-200">How long are my files stored?</AccordionTrigger>
                    <AccordionContent className="text-gray-300">
                      Your downloaded videos and ZIP files are automatically removed after 72 hours to conserve storage space. Please download your files before they expire.
                    </AccordionContent>
                  </AccordionItem>
                  
                  <AccordionItem value="item-4" className="border-gray-700">
                    <AccordionTrigger className="text-gray-200">What happens if a download fails?</AccordionTrigger>
                    <AccordionContent className="text-gray-300">
                      If a download fails, you can retry individual videos or entire collections. Failed downloads don't count against your limit.
                    </AccordionContent>
                  </AccordionItem>
                  
                  <AccordionItem value="item-5" className="border-gray-700">
                    <AccordionTrigger className="text-gray-200">How accurate are the transcripts?</AccordionTrigger>
                    <AccordionContent className="text-gray-300">
                      Our AI-powered transcription typically achieves 90-95% accuracy for clear audio. Background noise, music, or heavy accents may reduce accuracy.
                    </AccordionContent>
                  </AccordionItem>
                </Accordion>
              </CardContent>
            </Card>
            
            {/* Contact Form */}
            <Card className="bg-tokscript-card border-gray-800">
              <CardHeader>
                <CardTitle>Contact Support</CardTitle>
                <CardDescription>Need more help? Send us a message.</CardDescription>
              </CardHeader>
              <CardContent>
                <form className="space-y-4">
                  <div className="space-y-2">
                    <Input placeholder="Your Name" className="bg-gray-800 border-gray-700" />
                  </div>
                  <div className="space-y-2">
                    <Input placeholder="Email Address" type="email" className="bg-gray-800 border-gray-700" />
                  </div>
                  <div className="space-y-2">
                    <Textarea 
                      placeholder="Describe your issue..." 
                      className="bg-gray-800 border-gray-700 min-h-[120px]" 
                    />
                  </div>
                  <Button className="w-full bg-tokscript-cta hover:bg-tokscript-cta/90 text-black">
                    Send Message
                  </Button>
                </form>
              </CardContent>
            </Card>
          </div>
        </div>
      </main>
      <footer className="border-t border-gray-800 py-6 mt-8">
        <div className="container mx-auto flex flex-col md:flex-row justify-between items-center px-4">
          <div className="mb-4 md:mb-0">
            <div className="text-xl font-bold">
              <span className="text-white">tok</span>
              <span className="text-tokscript-cta">script</span>
            </div>
            <p className="text-sm text-gray-400 mt-1">© 2024 TokScript. All rights reserved.</p>
          </div>
          <SocialMediaIcons />
        </div>
      </footer>
    </div>
  );
};

export default SupportPage;
